// extracted by mini-css-extract-plugin
export var dataCell = "_ri-2";
export var dataRow = "_ri-0";
export var headerRow = "_ri-1";